import axios from 'axios'
import router from '../router'
import { Message } from 'element-ui'

const http = axios.create({
  timeout: 5000
})

http.interceptors.response.use(function (response) {
  return response.data
}, (error) => {
  if (!error.response) {
    return Promise.reject(error)
  }

  switch (error.response.status) {
    case 400:
      Message.error({
        message: error.response.data.msg
      })
      break

    case 401:
      router.push({
        name: 'Login'
      })
      Message.error({
        message: '登录状态已过期，请刷新页面重新登录',
        duration: 5000
      })
      break

    case 403:
      Message.error({
        message: '抱歉，你无权访问该页面'
      })
      break

    case 404:
      Message.error({
        message: '请求失败，目标不存在'
      })
      break

    case 500:
      Message.error({
        message: '服务器正在维护，请稍后再试'
      })
      break

    default:
      Message.error({
        message: error.response.data.msg
      })
      break
  }
  return Promise.reject(error)
})

// Add auth info and json content type to header
const wrapAuthInfo = (data, contentType = '') => {
  // Wrap header
  const userInfoStr = localStorage.getItem('user_info')
  if (!userInfoStr) {
    return data
  }

  const userInfo = JSON.parse(userInfoStr)
  data.headers = {
    'x-access-token': userInfo.token,
    'secret': userInfo.secret
  }
  return data
}

export const authReq = {
  get: (url, params = {}, timeout = 5000) => {
    return http.get(url, wrapAuthInfo({ timeout, params }))
  },
  post: (url, data = {}, timeout = 5000) => {
    return http.post(url, data, wrapAuthInfo({ timeout }))
  },
  uploadPost: (url, data = {}) => {
    return axios.post(url, data, wrapAuthInfo({}))
  },
  put: (url, data = {}) => {
    return http.put(url, data, wrapAuthInfo({}))
  },
  uploadPut: (url, data = {}) => {
    return axios.put(url, data, wrapAuthInfo({}))
  },
  delete: (url, data = {}) => {
    return http.delete(url, wrapAuthInfo({ data }))
  }
}

export const req = {
  get: (url, params = {}) => {
    return http.get(url, {}, {
      headers: {
        'Content-Type': 'application/json; charset=UTF-8'
      }
    })
  },
  post: (url, data = {}) => {
    return http({
      url,
      method: 'post',
      data: data,
      headers: {
        'Content-Type': 'application/json'
      }
    })
    // return http.post(url, JSON.stringify(data), {
    //   headers: {
    //     'Content-Type': 'application/json; charset=UTF-8'
    //   }
    // })
  },
  put: (url, data = {}) => {
    return http.put(url, data, {
      headers: {
        'Content-Type': 'application/json; charset=UTF-8'
      }
    })
  },
  delete: (url, data = {}) => {
    return http.delete(url, data, {
      headers: {
        'Content-Type': 'application/json; charset=UTF-8'
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/utils/http.js